import React, { useState } from 'react';
import UploadDocuments from '../components/candidatesSteps/UploadDocuments';
import { useProcessingHandler } from '../hooks/useProcessingHandler';
import Processing from '../components/candidatesSteps/Processing';
import ChatAssistant from '../components/candidatesSteps/ChatAssistant';
import MatchCompanies from '../components/candidatesSteps/MatchCompanies';
import SearchCandidates from '../components/candidatesSteps/SearchCandidates';
import { Spin } from 'antd';
import { RootState } from '../redux';
import { useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import "./index.css"

const steps = [
  { title: 'Describe Your Need' },
  { title: 'Explore Matching Companies' },
  { title: 'Define Role Requirements' },
  { title: 'View Suggested Employees' }
];

interface Props {
  title?: string;
}

const ChatWorkflow: React.FC<Props> = ({ title }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [sessionIdCompany, setSessionIdCompany] = useState('');
  const [sessionIdCandidate, setSessionIdCandidate] = useState('');
  const [promptCompany, setPromptCompany] = useState('');
  const [promptCandidate, setPromptCandidate] = useState('');
  const {
    isProcessing,
    processingContext,
    startProcessing,
    startReprocessing
  } = useProcessingHandler();
  const { companies, candidates, services } = useSelector((state: RootState) => state.analysis);
  const isResultView = currentStep === 1 || currentStep === 3
  const isCompanyView = currentStep === 1
  const handleNext = async () => {
    if (currentStep === 0) {
      setSessionIdCompany(uuidv4());
      await startProcessing(
        uploadedFiles,
        {
          title: 'Finding Matching Companies',
          description: uploadedFiles.length > 0
          ? `Analyzing your input and ${uploadedFiles.length} uploaded ${uploadedFiles.length > 1 ? 'files' : 'file'} to find relevant matches`
          : `Analyzing your input to find companies that match your description`,
        },
        promptCompany
      );
    } else if (currentStep === 2) {
      setSessionIdCandidate(uuidv4());
      await startReprocessing(
        {
          title: 'Finding Relevant Employees',
          description: 'Reanalyzing your request to identify employees who best match your description.',          
        },
        services.progress.taskId,
        promptCandidate ? promptCandidate : promptCompany
      );
    }

    setCurrentStep(currentStep + 1);
    console.log('Final currentStep (after await):', currentStep + 1);
  };

  return (
    <div className="workflow-container">
      <div className="custom-steps-container">
        {steps.map((item, index) => (
          <div
            key={item.title}
            className={`custom-step ${currentStep === index ? 'active' : ''}`}
          >
            <div className="step-circle">{index + 1}</div>
            <div className="step-title">{item.title}</div>
          </div>
        ))}
      </div>

      <div className="workflow-step-content" style={isResultView && !isProcessing ? { padding: "unset" } : {}}>
        {isProcessing && processingContext ? (
          <Processing
            isProcessing={isProcessing}
            title={processingContext.title}
            description={processingContext.description}
          />
        ) : (
          <>
            {!isResultView ? (
              <UploadDocuments
                uploadedFiles={uploadedFiles}
                setUploadedFiles={setUploadedFiles}
                isCandidateFlow={currentStep === 2 ? true : false}
                promptCompany={promptCompany}
                promptCandidate={promptCandidate}
                setPromptCompany={setPromptCompany}
                setPromptCandidate={setPromptCandidate}
                onStartProcessing={handleNext}
                onBack={() => setCurrentStep(currentStep - 1)}
              />
            ) : (
              <div className="step-split-layout">
                <div className="match-section scrollable-panel">
                  {isCompanyView ? 
                    <MatchCompanies onNext={() => handleNext()} onBack={() => setCurrentStep(currentStep - 1)} />
                    : <SearchCandidates onBack={() => setCurrentStep(currentStep - 1)} />}
                </div>
                <Spin spinning={isCompanyView ? 
                  companies.loading === 'idle' || companies.loading === 'pending' 
                  :
                  candidates.loading === 'idle' || candidates.loading === 'pending'}
                >
                  <div className="chat-section">
                    <ChatAssistant
                      sessionId={isCompanyView ? sessionIdCompany : sessionIdCandidate}
                      welcomeMessage={isCompanyView? 'Would you like help reviewing these company matches?' : "How can I help you evaluate these candidate matches?"}
                      chatId={"c63209b9-9a5d-4873-a9a1-b345138660a9"}
                    />
                  </div>
                </Spin>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ChatWorkflow;
